import { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import ItemAttributes from './ItemAttributes';

const AttributesSection = ({ isView, attributes, defaultLanguage, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const { t } = useTranslation();

    return (
        <div style={{ margin: '8px 0' }}>
            <div
                onClick={() => setIsOpen(prev => !prev)}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 0', cursor: 'pointer' }}
            >
                {isOpen ? (
                    <ExpandLessIcon className="sidebar-menu-arrow" />
                ) : (
                    <ExpandMoreIcon className="sidebar-menu-arrow" />
                )}
                <Typography variant="body2">{t('MenusPage.additionalAttributes')}</Typography>
            </div>
            {isOpen ? (
                <ItemAttributes
                    isView={isView}
                    attributes={attributes}
                    defaultLanguage={defaultLanguage}
                    onChange={onChange}
                />
            ) : null}
        </div>
    );
};

export default AttributesSection;
